import { downloadSigningAsset, uploadSigningAsset, type SigningAssetKind } from '@/core/api/storage'
import { me } from '@/core/data/session'
import { blobToBase64 } from '@/core/api/http'
import { trackSettingsWrite } from '@/core/api/settingsWrites'

import { toPngBlob } from '@/core/lib/files'

export type SigningAsset = { base64: string; format: 'png' }

export function memberSignaturePath(memberId: string): string {
  return `member/${memberId}/signature.png`
}

export function orgStampPath(organisationId: string): string {
  return `${organisationId}/stamp.png`
}

export async function loadMemberSignatur(memberId?: string): Promise<SigningAsset | undefined> {
  return loadSigningAsset('member-signature', memberId ?? (await me()).userId)
}

export async function loadStempel(organisationId?: string): Promise<SigningAsset | undefined> {
  return loadSigningAsset('org-stamp', organisationId ?? (await me()).organisationId)
}

export function signingAssetDataUrl(asset: SigningAsset): string {
  return `data:image/${asset.format};base64,${asset.base64}`
}

export function saveMemberSignatur(memberId: string, blob: Blob): Promise<SigningAsset> {
  return trackSettingsWrite(async (identity) => {
    const png = await toPngBlob(blob)
    await uploadSigningAsset('member-signature', memberId, png, identity)
    return { base64: await blobToBase64(png), format: 'png' }
  })
}

export function saveStempel(organisationId: string, blob: Blob): Promise<SigningAsset> {
  return trackSettingsWrite(async (identity) => {
    const png = await toPngBlob(blob)
    await uploadSigningAsset('org-stamp', organisationId, png, identity)
    return { base64: await blobToBase64(png), format: 'png' }
  })
}

async function loadSigningAsset(
  kind: SigningAssetKind,
  ownerId: string,
): Promise<SigningAsset | undefined> {
  try {
    const blob = await downloadSigningAsset(kind, ownerId)
    return { base64: await blobToBase64(blob), format: 'png' }
  } catch {
    const path = kind === 'org-stamp' ? orgStampPath(ownerId) : memberSignaturePath(ownerId)
    console.warn(`Signing-Asset nicht lesbar: signing-assets/${path} (fehlt die Datei?)`)
    return undefined
  }
}
